import {
  Digest,
  DigestsService,
  Feed,
  Material,
  MaterialsService,
} from '../api';

interface DigestsProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Digest[] | undefined; total: number | undefined }>;
  getOne: (resource: string, params: any) => Promise<{ data: Digest }>;
  create: (resource: string, params: any) => Promise<{ data: Digest }>;
  update: (resource: string, params: any) => Promise<{ data: Digest }>;
  delete: (resource: string, params: any) => Promise<{ data: {} }>;
  getMany: (resource: string, params: any) => Promise<{ data: Digest[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Digest[] }>;
  updateMany: (resource: string, params: any) => Promise<{ data: Digest[] }>;
  deleteMany: (resource: string, params: any) => Promise<{ data: {} }>;
}

export const digestsDataProvider: DigestsProviderResource = {
  getList: async (resource, params) => {
    const { pagination } = params;
    console.log('getList', pagination);
    const data = await DigestsService.getDigests();
    if (!data) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: data.items,
      total: data.items?.length,
    };
  },
  getOne: async (resource, params) => {
    const { id } = params;

    const feed = await DigestsService.getDigest(id);
    return {
      data: feed,
    };
  },
  create: async (resource, params) => {
    const feed = await DigestsService.createDigest(params.data);
    return {
      data: feed,
    };
  },
  update: async (resource, params) => {
    const feed = await DigestsService.updateDigest(params.id, params.data);
    return {
      data: feed,
    };
  },
  delete: async (resource, params) => {
    const { id } = params;
    await DigestsService.deleteDigest(id);
    return {
      data: {},
    };
  },
  getMany: async (resource, params) => ({
    data: [],
  }),
  getManyReference: async (resource, params) => ({
    data: [],
  }),
  updateMany: async (resource, params) => ({
    data: [],
  }),
  deleteMany: async (resource, params) => {
    // const promises = params.ids.map((id: number) => UserService.deleteUser(id));
    const promises = params.ids.map((id: number) => console.log(id));

    await Promise.all(promises);

    return {
      data: {},
    };
  },
};
